import { version, GlobalWorkerOptions } from 'pdfjs-dist';
export { default as DocumentsAppConfigsContext, DocumentsAppConfigsProvider } from "./contexts/DocumentsAppConfigsContext.js";
export { default as useDocumentsAppConfigs } from "./hooks/useDocumentsAppConfigs.js";
export { default as Experiment } from "./components/Experiment.js";
export { default as DrawablePdf } from "./containers/DrawablePdf.js";
export { default as SignatureModal } from "./components/SignatureModal.js";
export { default as SignedSuccessModal } from "./components/SignedSuccessModal.js";
export { default as FillablePdf } from "./containers/FillablePdf.js";
export { default as useGetTemplate } from "./hooks/api/useGetTemplate.js";
export { default as useCreateDocumentPreview } from "./hooks/api/useCreateDocumentPreview.js";
export { default as useCreateDocument } from "./hooks/api/useCreateDocument.js";
export { default as Header } from "./components/Header.js";
export { default as LayoutWrapper } from "./components/LayoutWrapper.js";
export { default as useGetTemplates } from "./hooks/api/useGetTemplates.js";
export { default as TemplatePicker } from "./components/TemplatePicker.js";
export { default as FillableTemplate } from "./containers/FillableTemplate.js";
export { default as useGetDocument } from "./hooks/api/useGetDocument.js";
export { default as ViewableDocument } from "./containers/ViewableDocument.js";
export { default as useCreateDocumentDownload } from "./hooks/api/useCreateDocumentDownload.js";
export { default as DocumentDownloadButton } from "./components/DocumentDownloadButton.js";
export { default as FillableDocument } from "./containers/FillableDocument.js";
export { default as FormProperties } from "./containers/FormProperties.js";
export { default as DrawableFieldProperties } from "./components/annotation/drawable/DrawableFieldProperties.js";
export { default as TemplateEditor } from "./containers/TemplateEditor.js";
export { default as useUploadTemplate } from "./hooks/api/useUploadTemplate.js";
export { default as useDeleteTemplate } from "./hooks/api/useDeleteTemplate.js";
export { default as useCreateTemplatePreview } from "./hooks/api/useCreateTemplatePreview.js";
export { default as useDuplicateTemplate } from "./hooks/api/useDuplicateTemplate.js";
export { default as useDeleteDocument } from "./hooks/api/useDeleteDocument.js";
var workerSrcCdn = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(version, "/pdf.worker.js");
GlobalWorkerOptions.workerSrc = workerSrcCdn;